import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./Pages/Home";
import { BetSlipProvider } from "./context/BetSlipContext";
import Login from "./component/Login";
import Register from "./component/Register";
import Casino from "./Pages/Casino";
import Promotions from "./Pages/Promotions";
import Listing from "./Pages/9wicket/Listing";
import MatchDetail from "./Pages/matchDetail/MatchDetail";
import { ThemeProvider } from "./context/ThemeContext";
import Deposit from "./Pages/Account/Deposit";
import BettingHistory from "./Pages/Account/BettingHistory";
import Turnover from "./Pages/Account/Turnover";
import TransactionRecords from "./Pages/Account/TransactionRecords";
import ResetPassword from "./Pages/Account/ResetPassword";
import Profile from "./Pages/Account/Profile";
import Vip from "./Pages/Account/Vip";
import Message from "./Pages/Account/Message";
import {
  ProtectedRoute,
  ProtectedRouteLogin,
} from "./component/ProctectedRoute";
import Refrel from "./Pages/Account/Refrel";
import ForgotPassword from "./Pages/ForgotPassword";
import Index from "./Pages/Velkie/Index";
import Detail from "./Pages/Velkie/MatchDetail/Detail";
import "./app.css";

import LeagueVelki from "./Pages/Velkie/LeagueVelki";
import SkyIndex from "./Pages/Sky/Index";
import InPlay from "./Pages/Sky/InPlay";
import DetailSky from "./Pages/Sky/MatchDetail/DetailSky";
import FavouriteVelkie from "./Pages/Velkie/FavouriteVelkie";
import FavouriteSky from "./Pages/Sky/FavouriteSky";
import SportsNew from "./Pages/Sky/SportsNew";
import AccountSky from "./Pages/Sky/AccountSky";
import AccountWeb from "./Pages/Sky/Account/AccountWeb";
import MyBetsWeb from "./Pages/Sky/Account/MyBetsWeb";
import Activitylog from "./Pages/Sky/Account/Activitylog";
import AccountStatement from "./Pages/Sky/Account/AccountStatement";
import BalanceOverview from "./Pages/Sky/Account/BalanceOverview";
import CurrentBet from "./Pages/Velkie/Account/CurrentBet";
import HomeSkyWeb from "./Pages/Sky/WebSky/Home";
import DetailWebSky from "./Pages/Sky/WebSky/Detail";
import Inplay from "./Pages/Sky/WebSky/Inplay";
import FavouriteSkyWeb from "./Pages/Sky/WebSky/FavouriteSky";

import ModalLayout from "./Pages/ModalLayout";
import { isMobile } from "react-device-detect";
import ActivityLog from "./Pages/Velkie/Account/ActivityLog";
import ResultSky from "./Pages/Sky/ResultSky";
import BettingHistoryVelkie from "./Pages/Velkie/Account/BettingHistoryVelkie";
import AffiliateLink from "./component/AffiliateLink";
import AccountStatementDefault from "./Pages/Account/AccountStatement";
import Terms from "./Pages/Terms";
import PaymentStatus from "./Pages/PaymentStatus";
import CustomerSupport from "./CustomerSupport.js/Index";
import FreeSpin from "./Pages/Account/FreeSpin";
import RealTimeBonus from "./Pages/Account/RealTimeBonus";
import WinnerBoard from "./Pages/Account/WinnerBoard";
import DailyStreakChallenge from "./Pages/Account/DailyStreakChallenge";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ThemeProvider>
          <AuthProvider>
            <BetSlipProvider>
              {isMobile ? <Outlet /> : <ModalLayout />}{" "}
            </BetSlipProvider>
          </AuthProvider>
        </ThemeProvider>
      }
    >
      <Route path="/" element={<Home />} />{" "}
      <Route path="/terms/:type" element={isMobile ? <Terms /> : null} />{" "}
      <Route
        path="/account-statement"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <AccountStatementDefault />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/exchange/profile"
        element={
          <ProtectedRouteLogin>
            <AccountWeb />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/my-bets"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/profit-loss"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/activity-log"
        element={
          <ProtectedRouteLogin>
            <Activitylog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatement />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/balance-overview"
        element={
          <ProtectedRouteLogin>
            <BalanceOverview />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/menu/active-log"
        element={
          <ProtectedRouteLogin>
            <ActivityLog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/menu/current-bet"
        element={
          <ProtectedRouteLogin>
            <CurrentBet />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/menu/bet-history"
        element={
          <ProtectedRouteLogin>
            <BettingHistoryVelkie />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/result-sky"
        element={
          <ProtectedRouteLogin>
            <ResultSky />
          </ProtectedRouteLogin>
        }
      />{" "}
      {/* <Route path="/sports" element={<Listing />} /> */}
      <Route
        path="/sports-velki"
        element={
          <ProtectedRouteLogin>
            <Index />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/sports-sky/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky-new"
        element={
          <ProtectedRouteLogin>
            <SportsNew />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/account-sky"
        element={
          <ProtectedRouteLogin>
            <AccountSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-velkie"
        element={
          <ProtectedRouteLogin>
            <FavouriteVelkie />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <FavouriteSky /> : <FavouriteSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/inplay-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <InPlay /> : <Inplay />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/league-velki"
        element={
          <ProtectedRouteLogin>
            <LeagueVelki />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/casino" element={<Casino />} />
      <Route
        path="/match-detail/:eventId/:marketId"
        element={<MatchDetail />}
      />
      <Route
        path="/match-detail/:eventId/:marketId/:type"
        element={<MatchDetail />}
      />
      <Route
        path="/wallet/:type"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <Deposit />
            </ProtectedRouteLogin>
          ) : null
        }
      />
      <Route
        path="/wallet/:type/:offerCode"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <Deposit />
            </ProtectedRouteLogin>
          ) : null
        }
      />
      <Route
        path="/login"
        element={
          isMobile ? (
            <ProtectedRoute>
              <Login />
            </ProtectedRoute>
          ) : null
        }
      />{" "}
      <Route
        path="/register"
        element={
          isMobile ? (
            <ProtectedRoute>
              <Register />
            </ProtectedRoute>
          ) : null
        }
      />{" "}
      <Route
        path="/affiliate-link"
        element={
          isMobile ? (
            // <ProtectedRouteLogin>
            <AffiliateLink />
          ) : // </ProtectedRouteLogin>
          null
        }
      />{" "}
      <Route
        path="/forgot-password"
        element={
          isMobile ? (
            <ProtectedRoute>
              <ForgotPassword />
            </ProtectedRoute>
          ) : null
        }
      />{" "}
      <Route path="/message" element={isMobile ? <Message /> : null} />
      <Route path="/promotions" element={isMobile ? <Promotions /> : null} />
      <Route
        path="/reset-password"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <ResetPassword />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/vip"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <Vip />
            </ProtectedRouteLogin>
          ) : null
        }
      />
      <Route
        path="/betting-history"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <BettingHistory />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/transaction-records"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <TransactionRecords />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/turnover"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <Turnover />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/free-spin"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <FreeSpin />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/real-time-bonus"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <RealTimeBonus />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route path="/winner-board" element={isMobile ? <WinnerBoard /> : null} />{" "}
      <Route
        path="/daily-streak-challenge"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <DailyStreakChallenge />
            </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/profile"
        element={
          isMobile ? (
            // <ProtectedRouteLogin>
              <Profile />
            // </ProtectedRouteLogin>
          ) : null
        }
      />{" "}
      <Route
        path="/refrel"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <Refrel />
            </ProtectedRouteLogin>
          ) : null
        }
      />
      <Route path="/proceed" element={<PaymentStatus />} />
      <Route
        path="/customer-support"
        element={
          <ProtectedRouteLogin>
            <CustomerSupport />
          </ProtectedRouteLogin>
        }
      />
    </Route>,
  ),
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
